import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withKeys as _withKeys, vModelText as _vModelText, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "flex flex-wrap space-y-2 md:space-x-2 md:flex-nowrap md:space-y-0" }
const _hoisted_3 = { class: "flex w-full" }
const _hoisted_4 = {
  value: "please-select",
  selected: "",
  disabled: ""
}
const _hoisted_5 = { value: "email" }
const _hoisted_6 = { value: "first_name" }
const _hoisted_7 = { value: "last_name" }
const _hoisted_8 = {
  key: 0,
  value: "organisations"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-search",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" })
], -1)

import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";

import TitleHeader from "@/components/TitleHeader.vue";
import UsersTable from "@/components/tables/UsersTable.vue";

import api from "@/api/api";
import { PaginationMeta, Role, User } from "@/types";
import { useUserStore } from "@/store";

import { useFilters } from "@/composables/filters";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserGroup',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();
const router = useRouter();
const userStore = useUserStore();

const roles = ref([] as Role[]);
const selectedRole = ref({} as Role);

const users = ref([] as User[]);
const meta = ref({} as PaginationMeta);

/** Search & Filters */
const { filters, getFiltersFromQuery, resetFilters, sortBy, setFilter, filter, setFilterNoRefresh } = useFilters(route);

async function search() {
  filters.value.role = String(route.params.role);
  filters.value.page = String(route.query.page) || 1;
  const response = await api.users.listUsers(filters.value);
  users.value = response.data.users;
  meta.value = response.meta;
}

roles.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.users.listRoles())),
  __temp = await __temp,
  __restore(),
  __temp
)).data.roles;

selectedRole.value = roles.value.find(i => i.name === route.params.role) || roles.value[0];

getFiltersFromQuery();
;(
  ([__temp,__restore] = _withAsyncContext(() => setFilterNoRefresh("search_type", (route.query.search_type as string) || "please-select"))),
  await __temp,
  __restore()
);
;(
  ([__temp,__restore] = _withAsyncContext(() => search())),
  await __temp,
  __restore()
);

if (!userStore.userIsAdmin) {
  router.push({ path: "/error" });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(TitleHeader, {
        title: _ctx.$t('role-users', [selectedRole.value.name])
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filters).search_type) = $event)),
            class: "block w-48 h-10 py-2 text-gray-900 border border-gray-600 rounded-l"
          }, [
            _createElementVNode("option", _hoisted_4, _toDisplayString(_ctx.$t("please-select")), 1),
            _createElementVNode("option", _hoisted_5, _toDisplayString(_ctx.$t("email")), 1),
            _createElementVNode("option", _hoisted_6, _toDisplayString(_ctx.$t("first-name")), 1),
            _createElementVNode("option", _hoisted_7, _toDisplayString(_ctx.$t("last-name")), 1),
            (_unref(userStore).userIsAdmin)
              ? (_openBlock(), _createElementBlock("option", _hoisted_8, _toDisplayString(_ctx.$t("organisation")), 1))
              : _createCommentVNode("", true)
          ], 512), [
            [_vModelSelect, _unref(filters).search_type]
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "search",
            id: "search",
            onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_unref(filter) && _unref(filter)(...args)), ["enter"])),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(filters).search) = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600",
            placeholder: "Search ...",
            required: ""
          }, null, 544), [
            [_vModelText, _unref(filters).search]
          ]),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(filter) && _unref(filter)(...args))),
            type: "submit",
            class: "flex items-center h-10 px-4 py-2 space-x-2 text-white rounded-r bg-primary hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300"
          }, [
            _hoisted_9,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("search")), 1)
          ])
        ])
      ])
    ]),
    _createVNode(UsersTable, {
      hideRolefilter: true,
      users: users.value,
      meta: meta.value,
      filters: _unref(filters),
      onSort: _unref(sortBy),
      onFilter: _unref(setFilter),
      onReset: _unref(resetFilters)
    }, null, 8, ["users", "meta", "filters", "onSort", "onFilter", "onReset"])
  ], 64))
}
}

})